import { loader } from './lib/Loader';
import menuToggle from './menuToggle';

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  menuToggle();

  if (document.getElementsByClassName('sidebar-menu').length) {
    import('./sidebar').then((module) => module.default());
  }

  if (document.getElementsByClassName('database__row').length) {
    import('./database').then((module) => module.default());
  }
});

loader('slider', '.slider');
loader('plyr', '.video');
loader('menu', '.menu__item--has-children');
loader('imageLightbox', '.content-block img');
